import { getCookie } from './cookieUtils'

/**
 * Shape the Meta pixel writes: `fb.<subdomainIndex>.<creationMs>.<payload>`.
 * The upper bound is loose because newer fbclids run to a few hundred chars.
 */
const FB_COOKIE_PATTERN = /^fb\.\d\.\d{10,16}\.[\w.-]{1,512}$/

export interface MetaPixelCookies {
  fbp?: string
  fbc?: string
}

function readFbCookie(name: string): string | undefined {
  const value = getCookie(name)?.trim()
  if (!value || !FB_COOKIE_PATTERN.test(value)) return undefined
  return value
}

/**
 * Meta's `_fbp` / `_fbc` cookies. The pixel sets them on `.shiptanbul.com`, so
 * they are readable here even when the ad click landed on the marketing site.
 * Both are absent when the visitor declined marketing cookies.
 */
export function getMetaPixelCookies(): MetaPixelCookies {
  const cookies: MetaPixelCookies = {}

  const fbp = readFbCookie('_fbp')
  if (fbp) cookies.fbp = fbp

  const fbc = readFbCookie('_fbc')
  if (fbc) cookies.fbc = fbc

  return cookies
}
